import { render, staticRenderFns } from "./BottomStepDescription.vue?vue&type=template&id=70b7d1fd"
import script from "./BottomStepDescription.vue?vue&type=script&lang=js"
export * from "./BottomStepDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports